module.exports={render:function (){with(this) {
  return _h('div', {
    class: [
      type === 'textarea' ? 'ion-textarea input-ios' : 'ion-input',
    ]
  }, [(type !== 'textarea') ? [_h('input', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (doCloseActive),
      expression: "doCloseActive"
    }],
    ref: "input",
    staticClass: "text-input ",
    class: ['text-input-' + theme],
    attrs: {
      "placeholder": placeholder,
      "number": type === 'number',
      "type": type,
      "disabled": disabled,
      "readonly": readonly
    },
    domProps: {
      "value": currentValue
    },
    on: {
      "change": function($event) {
        $emit('change', currentValue)
      },
      "focus": function($event) {
        active = true
      },
      "blur": function($event) {
        active = false
      },
      "input": handleInput
    }
  }), " ", (!disableClear) ? _h('ion-button', {
    staticClass: "text-input-clear-icon",
    attrs: {
      "type": "clear",
      "icon-only": ""
    },
    nativeOn: {
      "click": function($event) {
        handleClear($event)
      }
    }
  }, [_m(0)]) : _e()] : _h('textarea', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (doCloseActive),
      expression: "doCloseActive"
    }],
    ref: "input",
    staticClass: "text-input ",
    class: ['text-input-' + theme],
    attrs: {
      "placeholder": placeholder,
      "disabled": disabled,
      "readonly": readonly
    },
    domProps: {
      "value": currentValue
    },
    on: {
      "change": function($event) {
        $emit('change', currentValue)
      },
      "focus": function($event) {
        active = true
      },
      "blur": function($event) {
        active = false
      },
      "input": handleInput
    }
  }), " "])
}},staticRenderFns: [function (){with(this) {
  return _h('i', {
    staticClass: "ion-icon ion-ios-close-outline",
    attrs: {
      "role": "img"
    }
  })
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-764b01c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/input/src/input.vue
// module id = 163
// module chunks = 0